var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackWawe2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "#eeeeee",
      display: "block",
      zIndex: 1,
      position: "relative"
    },
    width: 1536,
    height: 1016,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1536 1016",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(768,508) scale(1,1) translate(-768,-508)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg-0.21484292191665944",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20dacd",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3490b8",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.21484292191665944)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "25s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "0s",
    values: "M0 0L 0 580.082586856736Q 192 715.2520326165464  384 694.6995932757077T 768 792.9624506212826T 1152 798.6417384563803T 1536 536.138596023321L 1536 0 Z;M0 0L 0 745.3074448620416Q 192 800.3301961931928  384 778.0323934964048T 768 529.4467611328462T 1152 602.2623377635992T 1536 617.2984649938369L 1536 0 Z;M0 0L 0 773.5980051642518Q 192 802.0999420434911  384 776.3689670053598T 768 678.5786932852606T 1152 769.579636754835T 1536 592.6789922385307L 1536 0 Z;M0 0L 0 580.082586856736Q 192 715.2520326165464  384 694.6995932757077T 768 792.9624506212826T 1152 798.6417384563803T 1536 536.138596023321L 1536 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.21484292191665944)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "25s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "-5s",
    values: "M0 0L 0 620.133912794749Q 192 779.8938729807949  384 758.5035952612036T 768 731.7122953640604T 1152 702.7885694492618T 1536 763.1036821893316L 1536 0 Z;M0 0L 0 548.1835708287014Q 192 631.9804937171227  384 580.9297730345662T 768 602.1508320857744T 1152 776.68902139705T 1536 588.1664003950351L 1536 0 Z;M0 0L 0 588.2274526225862Q 192 871.1487791935695  384 830.2154522630109T 768 560.3400872245671T 1152 737.2533424979207T 1536 769.6927611463018L 1536 0 Z;M0 0L 0 620.133912794749Q 192 779.8938729807949  384 758.5035952612036T 768 731.7122953640604T 1152 702.7885694492618T 1536 763.1036821893316L 1536 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.21484292191665944)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "25s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "-10s",
    values: "M0 0L 0 538.7798598245585Q 192 626.9311509508515  384 586.6241335303091T 768 729.1609770635565T 1152 527.0179340792638T 1536 605.5070671027095L 1536 0 Z;M0 0L 0 816.1268443400153Q 192 727.2027276699008  384 696.5964224580673T 768 811.4880877810215T 1152 731.5303079219511T 1536 829.6025345347002L 1536 0 Z;M0 0L 0 540.7161279933497Q 192 658.5371447803245  384 634.5949762463819T 768 735.7852228969548T 1152 626.5210220812235T 1536 550.1064102266682L 1536 0 Z;M0 0L 0 538.7798598245585Q 192 626.9311509508515  384 586.6241335303091T 768 729.1609770635565T 1152 527.0179340792638T 1536 605.5070671027095L 1536 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.21484292191665944)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "25s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "-15s",
    values: "M0 0L 0 673.3931022183848Q 192 672.3972936555399  384 654.6160861107944T 768 550.847298679275T 1152 536.7042150719705T 1536 752.7591038627022L 1536 0 Z;M0 0L 0 824.1998126328197Q 192 720.6767311541512  384 694.9670957796199T 768 703.7677803535125T 1152 542.0518282599404T 1536 664.6328475203986L 1536 0 Z;M0 0L 0 506.41219572170024Q 192 742.1345201160401  384 724.3654757568236T 768 676.3008248339988T 1152 510.88170777449926T 1536 736.2360800397055L 1536 0 Z;M0 0L 0 673.3931022183848Q 192 672.3972936555399  384 654.6160861107944T 768 550.847298679275T 1152 536.7042150719705T 1536 752.7591038627022L 1536 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.21484292191665944)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "25s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "-20s",
    values: "M0 0L 0 787.6927652390436Q 192 609.276012426334  384 587.2498700755831T 768 807.7738794470904T 1152 488.2728505175472T 1536 717.5365646234246L 1536 0 Z;M0 0L 0 527.7228233030917Q 192 628.5878847716576  384 606.3600854768175T 768 668.6525031073904T 1152 678.433805658015T 1536 618.65691622047L 1536 0 Z;M0 0L 0 697.8917653084327Q 192 828.5927517866305  384 790.9417075373769T 768 695.2173442679284T 1152 829.1278602334407T 1536 561.8095878396755L 1536 0 Z;M0 0L 0 787.6927652390436Q 192 609.276012426334  384 587.2498700755831T 768 807.7738794470904T 1152 488.2728505175472T 1536 717.5365646234246L 1536 0 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackWawe2);
export default __webpack_public_path__ + "static/media/backWawe2.113359024696e6d062ec829eb646f93e.svg";
export { ForwardRef as ReactComponent };